import React from 'react';
import './papercard.css'

const PaperCard = (props) => {
  return (
    <div className="paper-card">
        <h3>{props.title}</h3>
    </div>
  );
}

export default PaperCard;